import { NgModule } from '@angular/core';

import { CmpsFocusItemSummaryComponent } from './focus-item-summary.component';

@NgModule({
    declarations: [CmpsFocusItemSummaryComponent],
    exports: [CmpsFocusItemSummaryComponent],
})
export class CmpsFocusItemSummaryModule {}
